import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

const CustomScrollbars = (props) => (
  <Scrollbars
    {...props}
    autoHide
    autoHideTimeout={1000}
    autoHideDuration={200}
    renderTrackHorizontal={(props) => <div {...props} style={{ display: 'none' }} className="track-horizontal" />}
    // --- BARRA VERTICAL ---
    renderThumbVertical={({ style, ...props }) => (
      <div
        {...props}
        style={{
          ...style,
          backgroundColor: '#4a4a4a',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      />
    )}
  />
);

export default CustomScrollbars;
